<template>
  <div class="molecular-force-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>F_net = F_rep - F_att$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 渲染区：分子受力曲线 -->
      <div class="canvas-mixed simulation">
         <svg width="100%" height="220" viewBox="0 0 400 220">
            <!-- 坐标轴 -->
            <line x1="50" y1="110" x2="350" y2="110" stroke="#888" />
            <line x1="50" y1="180" x2="50" y2="30" stroke="#888" />
            <text x="360" y="115" fill="#888" font-size="9">距离 r</text>
            <text x="45" y="25" fill="#888" font-size="9">力 F</text>

            <!-- 合力曲线 -->
            <path :d="forceCurve" fill="none" stroke="#2ed573" stroke-width="2.5" />
            
            <!-- 两个分子演示 -->
            <g transform="translate(50, 60)">
               <circle cx="0" cy="0" r="10" fill="#00d2ff" />
               <circle :cx="r * 1.5" cy="0" r="10" fill="#00d2ff" />
               <text x="-20" y="-15" fill="#888" font-size="9">r_0 (平衡位置)</text>
            </g>

            <!-- 工作点 -->
            <circle :cx="50 + r * 1.5" :cy="110 - netForce * 5" r="4" fill="#ffd700" />
            
            <!-- 力箭头 -->
            <g v-if="Math.abs(netForce) > 1">
                <line :x1="50 + r * 1.5" y1="60" :x2="50 + r * 1.5 - netForce" y2="60" stroke="#ff4757" stroke-width="3" marker-end="url(#arr-f)" />
                <text :x="50 + r * 1.5" y="50" :fill="netForce > 0 ? '#ff4757' : '#00d2ff'" text-anchor="middle">
                   {{ netForce > 0 ? '斥力' : '引力' }}
                </text>
            </g>
         </svg>

         <div class="hud-top">
            <div class="stat">
               <label>合力性质</label>
               <span class="val" :style="{ color: netForce > 0 ? '#ff4757' : '#00d2ff' }">
                  {{ netForce > 0 ? 'Repulsive' : (Math.abs(netForce) < 1 ? 'Equilibrium' : 'Attractive') }}
               </span>
            </div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <label>调节分子中心距离 (r): {{ (r/10).toFixed(2) }} nm</label>
               <el-slider v-model="r" :min="10" :max="150" size="mini"></el-slider>
            </div>
         </div>

         <div class="discovery-note" v-latex>
            <p><strong>物理详解：</strong>由于分子间同时存在引力和斥力。当距离 $r &lt; r_0$ 时，斥力占主导；当 $r > r_0$ 时，引力占主导；当 $r = r_0$ 时，合力为零，系统能量最低（<strong>分子势能最低</strong>）。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MolecularForceViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      r: 60 // balanced at ~60
    }
  },
  computed: {
    r0() { return 60; },
    netForce() {
       // Simplified FJ potential: F = (r0/r)^13 - (r0/r)^7
       const ratio = this.r0 / this.r;
       return (Math.pow(ratio, 9) - Math.pow(ratio, 4)) * 30; // normalized
    },
    forceCurve() {
       let d = "M 60 30"; // Start close
       for(let r=15; r<=200; r+=2) {
          const ratio = this.r0 / r;
          const force = (Math.pow(ratio, 9) - Math.pow(ratio, 4)) * 30;
          const y = 110 - force * 5;
          d += ` L ${50 + r * 1.5} ${Math.max(20, Math.min(200, y))}`;
       }
       return d;
    }
  }
}
</script>

<style scoped lang="scss">
.molecular-force-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #2ed573; background: rgba(46,213,115,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-mixed { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; right: 15px; .val { font-family: monospace; } }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } }
.discovery-note { background: rgba(46, 213, 115, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
